window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};
window.AssessmentBuilder.Views.Mixins ??= {};

AssessmentBuilder.Views.Mixins.ThumbnailEditor = (superclass) =>
  (() => {
    const Cls = class extends superclass {
      constructor() {
        super(...arguments);
        this.initialize = this.initialize.bind(this);
        this.handleThumbnailModalComplete = this.handleThumbnailModalComplete.bind(this);
        this.render = this.render.bind(this);
        this.renderImagePreview = this.renderImagePreview.bind(this);
        this.showThumbnailEditorModal = this.showThumbnailEditorModal.bind(this);
        this.recordImageSettings = this.recordImageSettings.bind(this);
      }

      initialize() {
        super.initialize(...arguments);

        this.thumbnailEditor = new ThumbnailEditor();
        this.thumbnailEditor.setThumbnail(this.model.get("image"));
        this.thumbnailEditorModal = new Sparkle.ThumbnailEditorModal(this.thumbnailEditor, "Edit Image");

        // BEHAVIOUR

        jQuery(this.thumbnailEditorModal).on("complete", this.handleThumbnailModalComplete.bind(this));
        jQuery(this.thumbnailEditor).on("setThumbnail", this.renderImagePreview.bind(this));
        return this.$el.on("click", this.editorTriggerElementSelector, this.showThumbnailEditorModal.bind(this));
      }

      // EVENT HANDLERS

      handleThumbnailModalComplete() {
        this.recordImageSettings();
        return this.renderImagePreview();
      }

      // RENDERING

      render() {
        const value = super.render(...arguments);

        this.renderImagePreview();

        return value;
      }

      renderImagePreview() {
        const editorTriggerElement = this.$(this.editorTriggerElementSelector);
        // Don't render image if there is one but the thumbnail editor isn't ready to give us a cropped version of it
        if (_.isEmpty(this.model.get("image"))) {
          return editorTriggerElement.html(
            jQuery("<img>", { src: window.SparkleConfig.assetPaths.imageEmptyPlaceholderPath }),
          );
        } else if (this.thumbnailEditor.ready) {
          return editorTriggerElement.html(jQuery("<img>", { src: this.thumbnailEditor.getPreviewUrl() }));
        }
      }

      // HELPER FUNCTIONS

      showThumbnailEditorModal() {
        return this.thumbnailEditorModal.show();
      }

      recordImageSettings() {
        return this.model.set("image", this.thumbnailEditor.getThumbnail());
      }
    };
    Cls.prototype.editorTriggerElementSelector = '[data-assessment-builder-behaviour~="thumbnail-editor"]';
    return Cls;
  })();
